import { clsx } from 'clsx'
import type { FormStep } from '@/types'
import { FORM_STEPS, STEP_LABELS } from '@/types'
import styles from './StepIndicator.module.css'

interface StepIndicatorProps {
  steps?: FormStep[]
  currentStep: FormStep
  onStepClick?: (step: FormStep) => void
  completedSteps?: FormStep[]
}

/** Classi Font Awesome 6 (solid) per ogni step */
const STEP_FA: Record<FormStep, string> = {
  tipo_cliente: 'fa-solid fa-users',
  upload: 'fa-solid fa-cloud-arrow-up',
  anagrafica: 'fa-solid fa-user',
  documento: 'fa-solid fa-id-card',
  fornitura: 'fa-solid fa-bolt',
  pagamento: 'fa-solid fa-credit-card',
  riepilogo: 'fa-solid fa-circle-check',
  otp_request: 'fa-solid fa-shield-halved',
  otp_verify: 'fa-solid fa-key',
  firma: 'fa-solid fa-pen',
  completato: 'fa-solid fa-circle-check'
}

export function StepIndicator({
  steps = FORM_STEPS,
  currentStep,
  onStepClick,
  completedSteps = []
}: StepIndicatorProps) {
  const currentIndex = steps.indexOf(currentStep)

  const getStepStatus = (step: FormStep, index: number) => {
    if (completedSteps.includes(step)) return 'completed'
    if (index === currentIndex) return 'current'
    if (index < currentIndex) return 'passed'
    return 'upcoming'
  }

  return (
    <nav className={styles.container} aria-label="Progresso form">
      <ol className={styles.steps}>
        {steps.map((step, index) => {
          const status = getStepStatus(step, index)
          const isClickable = onStepClick && (status === 'completed' || status === 'passed')
          
          return (
            <li
              key={step}
              className={clsx(styles.step, styles[status])}
            >
              {index > 0 && (
                <div className={clsx(styles.connector, {
                  [styles.connectorActive]: index <= currentIndex
                })} />
              )}
              
              <button
                type="button"
                className={styles.stepButton}
                onClick={() => isClickable && onStepClick(step)}
                disabled={!isClickable}
                aria-current={status === 'current' ? 'step' : undefined}
              >
                <span className={styles.stepIcon}>
                  {status === 'completed' ? (
                    <i className="fa-solid fa-check" aria-hidden />
                  ) : (
                    <i className={STEP_FA[step]} aria-hidden />
                  )}
                </span>
                <span className={styles.stepLabel}>
                  {STEP_LABELS[step]}
                </span>
              </button>
            </li>
          )
        })}
      </ol>
      
      <div className={styles.mobileProgress}>
        <div className={styles.mobileProgressInfo}>
          <span className={styles.mobileStepText}>
            Passo {currentIndex + 1} di {steps.length}
          </span>
          <span className={styles.mobileStepLabel}>
            {STEP_LABELS[currentStep]}
          </span>
        </div>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${((currentIndex + 1) / steps.length) * 100}%` }}
          />
        </div>
      </div>
    </nav>
  )
}



